var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cm-card',{attrs:{"custom-class":"widget-tops__table","title":"Top losers today","is-close-content":_vm.coins.length === 0,"is-load":_vm.isLoad}},[_c('table-tops',{attrs:{"options":_vm.coins}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }